import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center">
      <div className="w-24 h-24 rounded-full bg-[var(--yellow)] border-2 border-[var(--text)] flex items-center justify-center mb-6" style={{ boxShadow: "5px 5px 0 0 var(--text)" }}>
        <XCircle size={44} weight="fill" className="text-[var(--text)]" />
      </div>
      <h1 className="font-display text-5xl">Payment cancelled</h1>
      <p className="text-[var(--text-2)] mt-2">No charge was made. Your basket is safe.</p>
      <button onClick={() => navigate("/cart")} className="btn-primary mt-6">Back to basket</button>
    </div>
  );
}
